import { Directive, ElementRef, Input, Renderer2, OnChanges, SimpleChanges, inject } from '@angular/core';
import { ValidationState } from '../services/forms.service';

@Directive({
  selector: '[wtValidationState]',
})
export class WtValidationStateDirective implements OnChanges {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  @Input('wtValidationState') validationState: ValidationState | null;

  ngOnChanges(changes: SimpleChanges): void {
    const validationState = changes.validationState.currentValue as ValidationState;

    if (validationState === ValidationState.Error) {
      this.renderer.addClass(this.el.nativeElement, 'has-error');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'has-error');
    }

    if (validationState === ValidationState.Success) {
      this.renderer.addClass(this.el.nativeElement, 'has-success');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'has-success');
    }
  }
}
